// extracted by mini-css-extract-plugin
module.exports = {"section":"_2PtIT","title":"_1-q0r","readMore":"_8zCqI","highlights":"_1HHH6","item":"_3GVXB","iframe":"_2WVne"};